import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Select,
  DatePicker,
  TimePicker,
  Spin,
  Row,
  Col,
} from "antd";
import dayjs from "dayjs";

const { Option } = Select;

const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const DoctorScheduleModal = ({
  open,
  onCancel,
  onSave,
  loading,
  form,
  doctor,
  scheduleData,
  scheduleLoading,
}) => {
  // Prefill form with existing schedule data
  useEffect(() => {
    if (
      scheduleData?.status &&
      Array.isArray(scheduleData.data) &&
      scheduleData.data.length > 0
    ) {
      const first = scheduleData.data[0];

      form.setFieldsValue({
        days: scheduleData.data.map((s) => s.days),
        timeFrom: first.startTime ? dayjs(first.startTime, "HH:mm") : null,
        timeTo: first.endTime ? dayjs(first.endTime, "HH:mm") : null,
        effectiveFrom: first.effectiveFrom
          ? dayjs(first.effectiveFrom, "YYYY-MM-DD")
          : null,
        effectiveTo: first.effectiveTo
          ? dayjs(first.effectiveTo, "YYYY-MM-DD")
          : null,
      });
    } else {
      form.resetFields();
    }
  }, [scheduleData, form]);

  return (
    <Modal
      title={`Doctor's Availability - ${doctor?.firstName ?? ""}`}
      open={open}
      onCancel={onCancel}
      onOk={onSave}
      width={600}
      confirmLoading={loading}
      style={{ top: 20 }}
    >
      {scheduleLoading ? (
        <Spin tip="Loading schedule..." />
      ) : (
        <Form form={form} layout="vertical">
          {/* Days */}
          <Form.Item
            label="Available Days"
            name="days"
            rules={[
              { required: true, message: "Please select available days" },
            ]}
          >
            <Select mode="multiple" placeholder="Select days" allowClear>
              {daysOfWeek.map((day) => (
                <Option key={day} value={day}>
                  {day}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {/* Common Start & End Time */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="timeFrom"
                label="Start Time"
                rules={[{ required: true, message: "Select start time" }]}
              >
                <TimePicker format="HH:mm" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="timeTo"
                label="End Time"
                rules={[{ required: true, message: "Select end time" }]}
              >
                <TimePicker format="HH:mm" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>

          {/* Effective Dates */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="effectiveFrom"
                label="Effective From"
                rules={[
                  { required: true, message: "Select effective from date" },
                ]}
              >
                <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="effectiveTo"
                label="Effective To"
                rules={[
                  { required: true, message: "Select effective to date" },
                ]}
              >
                <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
};

export default DoctorScheduleModal;

// import React, { useEffect } from "react";
// import { Modal, Form, Select, DatePicker, TimePicker, Spin, Row, Col } from "antd";
// import dayjs from "dayjs";

// const { Option } = Select;

// const daysOfWeek = [
//   "Monday",
//   "Tuesday",
//   "Wednesday",
//   "Thursday",
//   "Friday",
//   "Saturday",
//   "Sunday",
// ];

// const DoctorScheduleModal = ({
//   open,
//   onCancel,
//   onSave,
//   loading,
//   form,
//   doctor,
//   scheduleData,
//   scheduleLoading,
// }) => {
//   // Prefill form with existing schedule data
//   useEffect(() => {
//     if (
//       scheduleData?.status &&
//       Array.isArray(scheduleData.data) &&
//       scheduleData.data.length > 0
//     ) {
//       const schedules = scheduleData.data.map((s) => ({
//         day: s.days,
//         timeFrom: s.startTime ? dayjs(s.startTime, "HH:mm") : null,
//         timeTo: s.endTime ? dayjs(s.endTime, "HH:mm") : null,
//       }));

//       form.setFieldsValue({
//         effectiveFrom: scheduleData.data[0].effectiveFrom
//           ? dayjs(scheduleData.data[0].effectiveFrom, "YYYY-MM-DD")
//           : null,
//         effectiveTo: scheduleData.data[0].effectiveTo
//           ? dayjs(scheduleData.data[0].effectiveTo, "YYYY-MM-DD")
//           : null,
//         schedules,
//       });
//     } else {
//       form.resetFields();
//     }
//   }, [scheduleData, form]);

//   // Handle day selection change to update Form.List
//     const handleDaySelection = (selectedDays) => {
//     const existingSchedules = form.getFieldValue("schedules") || [];
//     const updatedSchedules = selectedDays.map((day) => {
//       const existing = existingSchedules.find((item) => item.day === day);
//       return (
//         existing || {
//           day,
//           timeFrom: null,
//           timeTo: null,
//         }
//       );
//     });
//     form.setFieldsValue({ schedules: updatedSchedules });
//   };

//   return (
//     <Modal
//       title={`Doctor's Availability - ${doctor?.firstName ?? ""}`}
//       open={open}
//       onCancel={onCancel}
//       onOk={onSave}
//       width={700}
//       confirmLoading={loading}
//       style={{ top: 20 }}
//     >
//       {scheduleLoading ? (
//         <Spin tip="Loading schedule..." />
//       ) : (
//         <Form form={form} layout="vertical">
//           {/* Day Selector */}
//           <Form.Item
//             label="Days"
//             name="days"
//             rules={[{ required: true, message: "Select available days" }]}
//           >
//             <Select
//               mode="multiple"
//               placeholder="Select days"
//               onChange={handleDaySelection}
//             >
//               {daysOfWeek.map((day) => (
//                 <Option key={day} value={day}>
//                   {day}
//                 </Option>
//               ))}
//             </Select>
//           </Form.Item>

//           {/* Dynamic day-time fields */}
//           <Form.List name="schedules">
//             {(fields) => (
//               <>
//                 {fields.map(({ key, name, ...restField }) => (
//                   <div
//                     key={key}
//                     style={{
//                       border: "1px solid #e5e5e5",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       marginBottom: "10px",
//                       backgroundColor: "#f9f9f9",
//                     }}
//                   >
//                     <Row gutter={16}>
//                       <Col span={8}>
//                         <Form.Item
//                           {...restField}
//                           name={[name, "day"]}
//                           label="Day"
//                           rules={[{ required: true }]}
//                         >
//                           <Select disabled>
//                             {daysOfWeek.map((day) => (
//                               <Option key={day} value={day}>
//                                 {day}
//                               </Option>
//                             ))}
//                           </Select>
//                         </Form.Item>
//                       </Col>
//                       <Col span={8}>
//                         <Form.Item
//                           {...restField}
//                           name={[name, "timeFrom"]}
//                           label="Start Time"
//                           rules={[{ required: true, message: "Select start time" }]}
//                         >
//                           <TimePicker format="HH:mm" style={{ width: "100%" }} />
//                         </Form.Item>
//                       </Col>
//                       <Col span={8}>
//                         <Form.Item
//                           {...restField}
//                           name={[name, "timeTo"]}
//                           label="End Time"
//                           rules={[{ required: true, message: "Select end time" }]}
//                         >
//                           <TimePicker format="HH:mm" style={{ width: "100%" }} />
//                         </Form.Item>
//                       </Col>
//                     </Row>
//                   </div>
//                 ))}
//               </>
//             )}
//           </Form.List>

//           {/* Effective Dates */}
//           <Row gutter={16}>
//             <Col span={12}>
//               <Form.Item
//                 name="effectiveFrom"
//                 label="Effective From"
//                 rules={[{ required: true, message: "Select start date" }]}
//               >
//                 <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="effectiveTo"
//                 label="Effective To"
//                 rules={[{ required: true, message: "Select end date" }]}
//               >
//                 <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
//               </Form.Item>
//             </Col>
//           </Row>
//         </Form>
//       )}
//     </Modal>
//   );
// };

// export default DoctorScheduleModal;
